module.exports = __webpack_public_path__ + "static/media/insta.ff01dc84.png";